import { memo } from 'react';

import { Flex } from '@/lib/v2/components/Layout/Stack';

import StepperItem, { StatusStepperItem, StepperItemProps } from './StepperItem';

import './Stepper.tailwind.css';

export type Steps = Omit<StepperItemProps, 'status'>[];

export interface StepperProps {
  currentStep: number;
  steps: Steps;
  isLoading?: boolean;
}

const Stepper = ({ steps, currentStep, isLoading = false }: StepperProps) => {
  if (isLoading) {
    return (
      <div className="flex w-full animate-pulse flex-col gap-4">
        <div className="flex w-full flex-col gap-2">
          <div className="h-3 w-10 rounded-md bg-gray-200"></div>
          <div className="h-6 w-20 rounded-md bg-gray-200"></div>
          <div className="h-4 w-2/3 rounded-md bg-gray-200"></div>
        </div>
        <div className="flex w-full flex-col gap-2">
          <div className="h-3 w-10 rounded-md bg-gray-200"></div>
          <div className="h-6 w-20 rounded-md bg-gray-200"></div>
          <div className="h-4 w-2/3 rounded-md bg-gray-200"></div>
        </div>
        <div className="flex w-full flex-col gap-2">
          <div className="h-3 w-10 rounded-md bg-gray-200"></div>
          <div className="h-6 w-20 rounded-md bg-gray-200"></div>
          <div className="h-4 w-2/3 rounded-md bg-gray-200"></div>
        </div>
      </div>
    );
  }

  return (
    <Flex column alignment="start" itemAlignment="start">
      {steps.map((step, index) => {
        const { id, ...restProps } = step;
        const stepNumber = index + 1;

        let status: StatusStepperItem;
        if (stepNumber < currentStep || currentStep === 0) status = 'done';
        else if (stepNumber === currentStep) status = 'current';
        else status = 'upcoming';
        return <StepperItem key={id} id={id} status={status} {...restProps}></StepperItem>;
      })}
    </Flex>
  );
};

export default memo(Stepper);
